import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

// components
import TemplatesList from "./TemplatesList";
import FormInput from "../FormInput";
import ReplyingMessage from "./ReplyingMessage";
import FilePreview from "./FilePreview";
import { typeFile } from "../../components/chat/ChatComponents";

// Utils
import { useForm } from "../../hooks/useForm";
import { fetchWithToken } from "../../api/fetch";

// Context
import { SocketContext } from "../../context/SocketContext";
import { ChatContext } from "../../context/chat/ChatContext";
import { AuthContext } from "../../context/AuthContext";
import ModalTxtFile from "../modals/ModalTxtFile";
import EmojiPckerCom from "./EmojiPckerCom";

const ChatFooter = ({ reply, setReply }) => {
  const [showEmoji, setShowEmoji] = useState(false);
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false); // Estado para controlar el modal
  const [file, setFile] = useState(null);
  const [isBlocked, setIsBlocked] = useState(false);
  const [textareaHeight, setTextareaHeight] = useState(35);
  const textAreaRef = useRef(null); // Referencia al textarea
  const { socket } = useContext(SocketContext);
  const { auth } = useContext(AuthContext);
  const { chatState } = useContext(ChatContext);
  const { activeChat, messages } = chatState;

  const messageInitialValues = {
    newMessage: "",
    newMessageMod: "",
    photo: null,
    tag: "",
    idtem: null,
  };

  const [values, handleInputChange, reset, setFormValue] = useForm({
    ...messageInitialValues,
  });
  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "35px"; // Reinicia la altura mínima
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`; // Ajusta la altura al contenido
    }
  }, [values.newMessage]); // Se ejecuta cada vez que cambia el valor del textarea

  useEffect(() => {
    setFormValue(messageInitialValues);
    setFile(null);
  }, [activeChat]);

  useEffect(() => {
    if (file || values.photo) {
      setShowModal(true); // Mostrar modal si hay archivo o foto
      setFormValue({
        ...values,
        newMessageMod: values.newMessage,
        newMessage: "",
      });
    }
  }, [file, values.photo]);

  const sendChatMessage = async (e) => {
    e.preventDefault();

    if (
      values.newMessage?.trim() === "" &&
      !file &&
      values.newMessageMod?.trim() === ""
    )
      return;

    const data = {
      sms: values.newMessage || values.newMessageMod,
      red: activeChat.red,
      id_user: activeChat.id,
      id_agent: auth.uid,
      photo: values.photo,
      etiqueta: values.tag,
      idRef: reply?.idgup || null,
      idtem: values.idtem,
    };
    if (!values.tag && data.sms.length > 0)
      data.sms = `*Agente ${auth.name}: * ${data.sms}`;

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const arrayBuffer = reader.result;

        const fileBuffer = {
          file: arrayBuffer,
          name: file.name,
          type: typeFile(file.type),
        };

        socket?.emit("upload", {
          file: fileBuffer,
          data,
        });
      };

      reader.readAsArrayBuffer(file);
    } else {
      socket?.emit("upload", {
        file,
        data,
      });
    }

    if (activeChat.smsunread > 0) socket?.emit("leidos", activeChat.id);

    setReply(null);
    setFile(null);
    setFormValue({ ...messageInitialValues });
    reset();
    setShowModal(false);

    const newMessage = document.getElementById("newMessage");
    newMessage.style.height = "35px";
  };
  console.log("*****smstem***:", values);
  useEffect(() => {
    const newMessage = document.getElementById("newMessage");
    newMessage.style.height = "35px";
    newMessage.style.height = newMessage.scrollHeight + "px";
  }, [values.newMessage]);

  useEffect(() => {
    const messageInput = document.getElementById("newMessage");
    const fileButton = document.getElementById("fileButton");

    const getLastMessage = async () => {
      const resp = await fetchWithToken(
        "sms/lastsms",
        { id: activeChat.id },
        "POST"
      );

      if (resp.ok) {
        setIsBlocked(false);
        messageInput.placeholder = `Ingrese su mensaje...${activeChat.id_user}`;

        messageInput.disabled = false;
        fileButton.disabled = false;
      } else {
        setIsBlocked(true);
        messageInput.placeholder =
          "La conversación ha caducado, no puedes enviar mensajes.";
        messageInput.disabled = true;
        fileButton.disabled = true;
      }
    };

    if (activeChat && activeChat.red !== "telegram") {
      getLastMessage();
    } else if (activeChat && activeChat.red === "telegram") {
      setIsBlocked(false);
      messageInput.placeholder = `Ingrese su mensaje...${activeChat.id_user}`;
      messageInput.disabled = false;
      fileButton.disabled = false;
    }
  }, [activeChat, messages]);
  const onCloseMod = () => {
    setShowModal(false);
    setFormValue({
      newMessage: "",
      newMessageMod: "",
      photo: null,
      tag: "",
      idtem: null,
    });
    setFile(null);
  };
  return (
    <div className="bg-light py-1">
      <form
        noValidate
        name="chat-form"
        id="chat-form"
        onSubmit={(e) => sendChatMessage(e)}
      >
        {/* TODO:// crear funcione spara insertar respus rap si es file en modal o no  */}
        <Row className="d-flex align-items-start mx-2">
          {reply && (
            <div
              className="replying-message-container"
              style={{ bottom: `${textareaHeight + 20}px` }}
            >
              <ReplyingMessage
                reply={reply}
                setReply={setReply}
                isReplyingMessage={true}
              />
            </div>
          )}

          <Col xs={3} lg={2} className="d-flex justify-content-between p-0">
            <EmojiPckerCom
              showEmoji={showEmoji}
              setShowEmoji={setShowEmoji}
              isBlocked={isBlocked}
              setFormValue={setFormValue}
            />
            <Button
              className="btn-light d-none d-md-block w-100 px-1"
              onClick={() => {
                setShowEmoji(!showEmoji);
              }}
            >
              <i className="uil uil-smile font-16" />
            </Button>

            <input
              type="file"
              id="fileInput"
              className="d-none"
              onChange={(event) => {
                const file = event.target.files[0];
                setFile(file);
              }}
            />

            <Button
              id="fileButton"
              className="btn-light w-100 px-1"
              onClick={() => document.getElementById("fileInput").click()}
            >
              <i className="uil uil-paperclip text-dark font-16" />
            </Button>

            <TemplatesList
              show={show}
              setShow={setShow}
              setFormValue={setFormValue}
              socialNetwork={activeChat?.red}
              isBlocked={isBlocked}
            />
          </Col>

          <Col xs={7} lg={9}>
            <FormInput
              ref={textAreaRef}
              id="newMessage"
              as="textarea"
              name="newMessage"
              value={values.newMessage}
              onChange={handleInputChange}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) sendChatMessage(e);
              }}
              autoCorrect="on" // 🔹 Habilita autocorrector
              spellCheck={true} // 🔹 Activa el corrector ortográfico
              style={{
                resize: "none",
                minHeight: "35px",
                maxHeight: "380px",
                overflowY: "auto",
              }}
            />
          </Col>

          <Col xs={2} md={1} className="d-flex align-items-end p-0">
            <Button type="submit" className="btn-success w-100">
              <i className="uil uil-message" />
            </Button>
          </Col>
        </Row>
      </form>
      {showModal && (
        <Modal show={showModal} onHide={onCloseMod} centered>
          <ModalTxtFile
            file={file || values.photo}
            setFile={setFile}
            values={values}
            setFormValue={setFormValue}
            handleInputChange={handleInputChange}
            onHide={() => setShowModal(false)}
            sendChatMessage={sendChatMessage}
          />
        </Modal>
      )}
    </div>
  );
};

export default ChatFooter;
